module.exports = __webpack_public_path__ + "static/img/valuess-01.6ca6f16d.png";